import { Article } from './article';
import { OperationProcess } from './operation-process';
export class ArticleVersion {

  constructor(
    public hash?: string,
    public article?: Article,
    public lastVersion?: boolean,
    public operations?: OperationProcess[]
  ) { }

  clone() {
    return new ArticleVersion(
      this.hash,
      this.article,
      this.lastVersion,
      this.operations
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/article-version.ts